import React from 'react'

const Error = () => {
  return (
    <div className ="Eror">The Page Doesn't Exists Mere bhai ! 😔😔</div>
  )
}

export default Error ;

